import { AuthStep } from 'constants/shared/enums';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
    LOGIN,
    AUTH_OTP,
    AUTH_TELL_GATEWAY,
    AUTH_EMAIL,
    AUTH_OPEN_BANKING,
} from '../../../../constants/shared/routes';
import { useRestrictedAction } from 'hooks';

const getRouteForStep = (step: AuthStep) => {
    switch (step) {
        case AuthStep.EMAIL_SIGN_IN_FLOW:
        case AuthStep.EMAIL_ACTIVATION_FLOW:
            return AUTH_EMAIL;
        case AuthStep.OTP:
            return AUTH_OTP;
        case AuthStep.TELL_GATEWAY:
            return AUTH_TELL_GATEWAY;
        default:
            return LOGIN;
    }
};

export const ActivationGuard = ({ children }) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const authStep = localStorage.getItem('authStep') as AuthStep;
    const cognitoToken = localStorage.getItem('cognitoToken');

    const currentStep = getRouteForStep(authStep);
    const allowedRoute = pathname.includes(AUTH_OPEN_BANKING);
    const {
        isAccountRestricted,
        handleRestrictedAction,
    } = useRestrictedAction();

    useEffect(() => {
        if (allowedRoute) {
            if (isAccountRestricted)
                return handleRestrictedAction(history.push(LOGIN));
            return;
        }
        if (!cognitoToken && !authStep) {
            return history.push("/auth");
        }
        history.push(currentStep);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, cognitoToken, allowedRoute, currentStep, authStep]);

    return children;
};
